import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconExclamation = createIcon({
  viewBox: '0 0 100 100',
  path: (
    <>
      <defs>
        <path
          id="wq0ijjm9ha"
          d="M33.806 0c18.409 0 33.333 14.924 33.333 33.333 0 18.41-14.924 33.334-33.333 33.334-18.41 0-33.334-14.924-33.334-33.334C.472 14.923 15.396 0 33.806 0zm0 43.056c-2.302 0-4.167 1.865-4.167 4.166s1.865 4.167 4.167 4.167c2.3 0 4.166-1.866 4.166-4.167 0-2.301-1.865-4.166-4.166-4.166zM35.972 12.5H31.64c-1.105 0-2 .895-2 2v21c0 1.105.895 2 2 2h4.333c1.105 0 2-.895 2-2v-21c0-1.105-.895-2-2-2z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0H100V100H0z"
                transform="translate(-132 -124) translate(24 124) translate(108)"
              />
              <g>
                <g transform="translate(-132 -124) translate(24 124) translate(108) translate(15.5 16.667) translate(.694)">
                  <mask id="st35kbk8eb" fill="#fff">
                    <use xlinkHref="#wq0ijjm9ha" />
                  </mask>
                  <use fill="#2D3237" xlinkHref="#wq0ijjm9ha" />
                  <g fill="#F7D250" mask="url(#st35kbk8eb)">
                    <path
                      d="M0 0H333.333V333.333H0z"
                      transform="translate(-132.167 -133.333)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </>
  ),
});

export default IconExclamation;
